module.exports = __webpack_public_path__ + "static/media/HRProfessional.8f9e9c5d.jpg";